<template>
  <transition v-bind="binds">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  props: {
    enterActiveClass: {
      type: Array,
      default: () => ([]),
    },
    enterClass: {
      type: Array,
      default: () => ([]),
    },
    leaveActiveClass: {
      type: Array,
      default: () => ([]),
    },
    leaveClass: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    binds () {
      return {
        'enter-class': this.mapClass(this.enterClass),
        'enter-active-class': this.mapClass(this.enterActiveClass),
        'leave-class': this.mapClass(this.leaveClass),
        'leave-active-class': this.mapClass(this.leaveActiveClass),
        ...this.$attrs,
      }
    },
  },
  methods: {
    mapClass (names) {
      return names.map(name => name).join(' ')
    },
  },
}
</script>

<style lang="scss">
@import '~animate.css';
</style>
